import { Component, OnInit } from '@angular/core';
import { ServicesService } from '@api/services.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  page = 1;
  limit = 10;
  servicesList;
  isClosed;
  public destroy$ = new Subject<void>();

  constructor(private servicesService: ServicesService) { }

  ngOnInit(): void {
    this.servicesService.getServicesList(this.isClosed, this.page, this.limit).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.servicesList = res;
      }
    )
  }
}
